var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as actions from 'app/actions/report';
import { addTask } from 'app/actions/task';
import http from 'app/services/http';
import moment from 'moment';
export const reportReducer = (state = {
    typeItems: [],
}, action) => {
    switch (action.type) {
        case 'REPORT_SET_TYPES': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { typeItems: items });
        }
        default:
            return state;
    }
};
export function reportTypeLoad() {
    return function reportTypeLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/report/type');
            return dispatch(actions.setTypeItems(data));
        });
    };
}
export function reportCreate(params) {
    return function reportCreateThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = getState();
            const { name, method } = getState().report.typeItems.find((item) => item.id === params.type_id);
            const { type_id, geofence_ids } = params, restParams = __rest(params, ["type_id", "geofence_ids"]);
            if (!restParams.ids || restParams.ids.trim() === '') {
                const checkedItems = state.map.transportCheckedItems;
                if (!checkedItems || checkedItems.length === 0) {
                    dispatch({
                        type: 'NOTIFICATION_ADD_QUEUE',
                        payload: {
                            text: 'Не выбраны транспортные средства.',
                            color: 'error',
                            timeout: 5000,
                        },
                    });
                    return { error: true };
                }
                restParams.ids = checkedItems.join(',');
            }
            // Формируем чистое тело запроса
            const requestBody = Object.assign({}, restParams);
            // geofence_ids нужен только для parking_time; из params он извлечён выше
            if (method === 'parking_time' && Array.isArray(geofence_ids)) {
                requestBody.geofence_ids = geofence_ids;
            }
            const response = yield http.post(`/report/${method}`, requestBody, {
                responseType: 'blob',
            });
            const { data, headers } = response;
            const contentType = headers['content-type'] || '';
            // Асинхронный ответ нового API (JSON в blob)
            if (contentType.includes('json')) {
                const payload = JSON.parse(yield data.text());
                if (payload.taskId) {
                    dispatch(addTask({
                        id: payload.taskId,
                        type: method,
                        status: 'pending',
                        params,
                        createdAt: new Date().toISOString(),
                    }));
                    dispatch({
                        type: 'NOTIFICATION_ADD_QUEUE',
                        payload: {
                            text: `Задача "${name}" создана. Ожидайте завершения.`,
                            color: 'info',
                            timeout: 5000,
                        },
                    });
                }
                return { success: true };
            }
            // Синхронный xlsx от монолита
            const timezoneOffset = config.timezoneOffsets.find((timezone) => String(timezone.value) === params.timezone);
            const documentLink = document.createElement('a');
            const disposition = headers['content-disposition'] || '';
            const formatMatch = disposition.match(/\.(\w+)(?:;|$)/);
            const format = (formatMatch === null || formatMatch === void 0 ? void 0 : formatMatch[1]) || 'xlsx';
            const date = moment().format('YYYY-MM-DD HHmm');
            const from = moment(params.from).format('YYYY-MM-DD HHmm');
            const to = moment(params.to).format('YYYY-MM-DD HHmm');
            const timeZone = (timezoneOffset === null || timezoneOffset === void 0 ? void 0 : timezoneOffset.title) || '+03:00';
            const documentName = `${date} ${name} ${from} - ${to} ${timeZone}.${format}`;
            documentLink.href = window.URL.createObjectURL(data);
            documentLink.setAttribute('download', documentName);
            documentLink.click();
            window.URL.revokeObjectURL(documentLink.href);
            return { success: true };
        });
    };
}
export default reportReducer;
